import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { requestWholesalerInfoPlayload } from '../../../../shared/models/model';
import { CommonModule } from '@angular/common';
import { WholesalerInfoService } from '../../../../shared/services/wholesaler.service';
import { Subscription } from 'rxjs';
import { EmulationService } from '../../../../shared/services/emulation.service';
import { SkeletonLineComponent } from '../../../../pages/skeleton-line/skeleton-line.component';

@Component({
  selector: 'app-contact-wholesaler',
  standalone: true,
  imports: [CommonModule, SkeletonLineComponent],
  templateUrl: './contact-wholesaler.component.html',
  styleUrl: './contact-wholesaler.component.scss',
})
export class ContactWholesalerComponent implements OnInit, OnDestroy {
  errorMessage: string = '';
  wholesalerInfo: any = {};
  hasWholesalerInfo: boolean = false;
  isemulatingUser: boolean = false;
  wholeSalerInfoSubscription: Subscription = new Subscription();
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  isLoading: boolean = false;
  constructor(
    private _wholeSalerService: WholesalerInfoService,
    private _emulationService: EmulationService,
  ) {}

  ngOnInit(): void {
    this.getWholesalerInfo();
  }

  getWholesalerInfo(): void {
    this.isLoading = true;
    const payLoad: requestWholesalerInfoPlayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    this._wholeSalerService.fetchWholesalerInfo(payLoad).subscribe({
      next: async (data: any) => {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        this.wholesalerInfo = data.wholesalerList;
        this.hasWholesalerInfo = this.wholesalerInfo?.length >= 1;
        this.isLoading = false;
      },
      error: (error: string) => {
        this.errorMessage = error;
        this.isLoading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.wholeSalerInfoSubscription.unsubscribe();
  }
}
